const BASE_URL = 'https://d28zjh2pk692s7.cloudfront.net';
export const getCloudinaryUrl = (
  originUrl: string,
  transforms: string,
  type: string = 'fetch'
): string => {
  return BASE_URL + `/${type}/${transforms}/${originUrl}`;
};
